uniform vec3 uTopLeft;
uniform vec3 uTopRight;
uniform vec3 uBottomRight;
uniform vec3 uBottomLeft;

varying vec2 vUv;

void main()
{
    vec3 bottomColor = mix(uBottomLeft, uBottomRight, vUv.x);
    vec3 topColor = mix(uTopLeft, uTopRight, vUv.x);
    gl_FragColor = vec4(mix(bottomColor, topColor, vUv.y), 1.0);
}
